module.exports = __webpack_public_path__ + "static/img/10063B_2_3_R_20190831_fit.251fd1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10063B_2_3_R_20190831_fit.png
// module id = ysBc
// module chunks = 0